import api from '@/api'

const account = {
  loginByPassword(data) {
    return api.post(`/account/login/password`, data)
  },
  getInformation() {
    return api.get(`/account/information`)
  },
  setInformation(data) {
    return api.patch(`/account/information`, data)
  },
  getPnsToken() {
    return api.get(`/assist/pns/token`)
  },
  loginByPns(data) {
    return api.post(`/account/login/pns`, data)
  },
  loginBySmsUp(data) {
    return api.post(`/account/login/sms-up`, data)
  },
  changeNickname(data) {
    return api.patch(`/account/nickname`, data)
  },
  changeAvatar(data) {
    return api.patch(`/account/avatar`, data)
  },
  unbindStore(data) {
    return api.patch(`/account/unbind`, data)
  },
  joinStore(data) {
    return api.patch(`/account/join`, data)
  },
  getAccountBookDetailList(params) {
    return api.get(`/account-book`, {
      params: params,
    })
  },
  changeSettlementMethod(data) {
    return api.patch(`/account/settlement-method`, data)
  },
  settlement(data) {
    return api.post(`/account-book/sub`, data)
  },
  settlementAccelerate() {
    return api.get(`/account-book/sub-accelerate`)
  },
  getSettlementState() {
    return api.get(`/account-book/sub/state`)
  },
  refreshToken() {
    return api.patch(`/account/token/refresh`)
  },
  getSSOCode() {
    return api.get(`/sso/code`)
  },
}

export default account
